import { ReactElement, useEffect } from 'react';
import { Link, useRouteError, useLocation } from 'react-router-dom';
import { Box } from '@twilio-paste/core/box';

import { EmptyState } from '@twiliointernal/org/twilio/e2-commons/shared/ui';
import {
  EmptyStateProps,
  EmptyStateVariant,
} from '@twiliointernal/org/twilio/e2-commons/shared/definitions';
import { copy, constants } from './definitions';
import logger from '../../../lib/logger';

import styles from './errorBoundary.module.css';

const ErrorBoundary = (): ReactElement => {
  const error = useRouteError();
  const location = useLocation();
  const isLandingPage = location?.pathname === '/';

  useEffect(() => {
    logger.error(`${constants.LOG_PREFIX}::${JSON.stringify(error)}`);
  }, []);

  const getEmptyStateProps = (): EmptyStateProps => {
    const errorString = JSON.stringify(error);

    if (errorString.includes('404')) {
      return {
        ...copy.errors.notFound,
        variant: EmptyStateVariant.noResults,
      };
    }

    return {
      ...copy.errors.unknown,
      variant: EmptyStateVariant.oops,
    };
  };

  const { heading, description, link, variant } = getEmptyStateProps();

  return (
    <Box as="main" className={styles.container}>
      <Box className={styles.cardContainer}>
        <EmptyState
          heading={heading}
          description={description}
          variant={variant}
          maxWidth="49rem"
        >
          {!isLandingPage && <Link to="/">{link}</Link>}
        </EmptyState>
      </Box>
    </Box>
  );
};

export default ErrorBoundary;
